module.exports = __webpack_public_path__ + "static/media/VanRocks-300x300.6abccf48.jpg";